module.exports = __webpack_public_path__ + "static/img/aizndh.9e0b7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aizndh.png
// module id = TKPM
// module chunks = 0